// first: on /demo, the demo's own storage stands in before any module reads this browser's (src/demo/storage.ts)
import "./demo/storage";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource/instrument-serif/400.css";
import "@fontsource-variable/pixelify-sans";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource/caveat/500.css";
import "@fontsource/caveat/600.css";
import "./styles/base.css";
import "./styles/canvas.css";
import "./styles/chrome.css";
import "./styles/widgets.css";
import "./styles/ours.css";
import "./styles/welcome.css";
import "./styles/panels.css";
import "./styles/boards.css";
import "./styles/calendar.css";
import "./styles/phone.css";
import { App } from "./App";
import { useStore } from "./state/store";
import { camera, useCamera } from "./canvas/camera";
import { Recover, watchForNewVersion } from "./chrome/Recover";
import { watchScrolling } from "./lib/scrollbars";
import { chat } from "./agent/store";
// SD: a chart linked to a sheet keeps its values current in the owner's tab
import "./boards/slides/chart/follow";

// a page left open across a deploy loads the new version rather than falling over
watchForNewVersion();
// a scroll bar shows while its area scrolls (Fixes 8; the style is in base.css)
watchScrolling();

// tests read state through this in development builds only
if (import.meta.env.DEV) {
  (window as unknown as { __cb: unknown }).__cb = { get: useStore.getState, set: useStore.setState, cam: useCamera.getState, chat };
  window.addEventListener("cb:fit", (e) => camera.fit((e as CustomEvent).detail, { maxZ: 1, pad: 40, animate: false }));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Recover>
      <App />
    </Recover>
  </StrictMode>,
);
